import {Decoder, equal, oneOf} from 'json-bouncer'

export type OrderPaid = 'Unpaid' | 'Paid' | 'Credited'

export function orderPaidAll(): OrderPaid[] {
    return ['Unpaid', 'Paid', 'Credited']
}

export function orderPaidDecoder(): Decoder<OrderPaid> {
    return oneOf([
        equal<'Unpaid'>('Unpaid'),
        equal<'Paid'>('Paid'),
        equal<'Credited'>('Credited'),
    ])
}

export function orderPaidLabel(orderPaid: OrderPaid): string {
    switch (orderPaid) {
        case 'Unpaid':
            return 'Nicht bezahlt'
        case 'Paid':
            return 'Bezahlt'
        case 'Credited':
            return 'Gutgeschrieben'
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OrderPaid.ts